<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}">
      <Breadcrumb routeName="HomeInlet" toName="频道设置" goPathName="首页快捷入口"></Breadcrumb>
      <a-row style="padding:10px 20px 0;">
        <detail-list :col="1">
          <detail-list-item term="开启频道">
            <a-radio-group v-model="channelStatus" @change="onChange">
              <a-radio :value="1">开启</a-radio>
              <a-radio :value="0">关闭</a-radio>
            </a-radio-group>
          </detail-list-item>
          <detail-list-item v-if="catalogId=='2'" term="屏蔽酒店类型">
            <a-checkbox-group v-model="filterStars" @change="updateStarSelect">
              <a-checkbox
                :value="item.code"
                v-for="item in starRangeList"
                :key="item.code"
              >{{ item.name }}
              </a-checkbox>
            </a-checkbox-group>
          </detail-list-item>
        </detail-list>
      </a-row>
      <!-- 专题 -->
      <SpecialTable></SpecialTable>
      <!-- Banner（默认“热门商品"） -->
      <BannerProHot :bannerProList="bannerProList" @updateImage="updateProImage" @change="addPro"
                    @deletePro="deletePro"></BannerProHot>
      <!-- 第一栏默认名称“特惠酒店” -->
      <PrettyProTable :specialProList="specialProList" :title="modularTitle" @change="addPro" @deletePro="deletePro"
                      @update="updateProList"></PrettyProTable>
      <!-- 选择的商品 -->
      <HomeProductView
        v-if="visiblePopup" :isDisabled="true"
        :visiblePopup="visiblePopup" :catalogId="Number(catalogId)"
        @close="closeView" @confirm="confirmProduct" path="user/home/getSelectProductAllList"
        baseUrl="userUrl"></HomeProductView>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import SpecialTable from '../component/specialTable'
import BannerProHot from '../component/BannerProHot'
import PrettyProTable from '../component/PrettyProTable'
import HomeProductView from '@/customComponents/HomeProductView/HomeProductView'

export default {
  name: 'ChannelSetting',
  components: {
    Breadcrumb,
    SpecialTable,
    BannerProHot,
    HomeProductView,
    PrettyProTable
  },
  data() {
    return {
      visiblePopup: false,
      catalogId: this.$route.query.catalogId,//商品类型
      bannerProList: [],
      specialProList: [],
      channelStatus: 0,
      merchantId: this.$store.getters.userInfo.merchantId,
      modularTitle: this.$route.query.catalogId == 1 ? '特惠门票' : '特惠酒店',
      starRangeList: [],
      filterStars: []
    }
  },
  mounted() {
    const catalogId = this.$route.query.catalogId
    this.getChannelStatus()
    this.getChannelProductList()
    if (String(catalogId) === '2') {
      this.getHotelStarList()
      this.getBindStarList()
    }
  },
  methods: {
    getBindStarList() {
      const merchantId = this.$store.getters.userInfo.merchantId
      const url = 'merchant/star/codes'
      this.getHttpServices().getWebDataService().get(url, { merchantId: merchantId })
        .then(list => {
          this.filterStars = list.map(code => String(code))
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
    },
    getHotelStarList() {
      const url = 'dict/star/list'
      return this.getHttpServices().getWebDataService().get(url)
        .then(list => {
          if (list && list.length > 0) {
            list.forEach(item => {
              item.code = String(item.code)
            })
          }
          this.starRangeList = list
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
    },

    updateStarSelect() {
      const url = 'merchant/star/batch'
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        starCodes: this.filterStars
      }
      this.getHttpServices().getWebDataService().post(url, params).then(res => {
        console.error('--updateStarSelect--', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      let params = {}
      params.channelStatus = e.target.value
      params.proType = this.catalogId
      let title = e.target.value == 1 ? '开启' : '关闭'
      this.getHttpServices().getUserService().post('user/merchantInfo/updateChannelStatus', params).then(res => {
        this.$message.success(title + '成功')
        this.channelStatus = e.target.value
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取开启关闭
    getChannelStatus() {
      this.getHttpServices().getUserService().get('user/merchantInfo/getChannelStatus?merchantId=' + this.merchantId + '&proType=' + this.catalogId).then(res => {
        this.channelStatus = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateProList() {
      this.getChannelProductList()
    },
    //获取banner和特惠酒店列表
    getChannelProductList() {
      this.bannerProList = []
      this.specialProList = []
      this.getHttpServices().getProService().get('product/proSpecial/getChannelProductList?merchantId=' + this.merchantId + '&proType=' + this.catalogId).then(res => {
        if (res && res.length > 0) {
          res.map((item) => {
            if (item.modularClassId == 5) {
              this.bannerProList = item.list ? item.list : []
            } else {
              this.specialProList = item.list ? item.list : []
              let title = this.catalogId == 1 ? '特惠门票' : '特惠酒店'
              this.modularTitle = item.modularTitle ? item.modularTitle : title
            }
          })
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 移除商品接口
    deletePro(data) {
      this.getLogUtils().logWithTag('删除', data)
      this.getHttpServices().getUserService().post('user/home/delHomeProduct?modularClassId=' + data.modularClassId + '&homeProId=' + data.proId + '&proType=' + this.catalogId).then(res => {
        this.getChannelProductList()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 添加商品
    addPro(id) {
      this.getLogUtils().logWithTag('添加商品', id)
      this.modularClassId = id
      this.visiblePopup = true
    },
    closeView() {
      this.visiblePopup = false
    },
    // 上传 删除 图片接口
    updateProImage(data) {
      let params = data
      this.getHttpServices().getUserService().post('user/home/homeProductImg', params).then(res => {
        this.getChannelProductList()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    confirmProduct(data) {
      this.getLogUtils().logWithTag('添加商品', data)
      let params = new Object()
      let modularTitle = ''
      params.modularClassID = this.modularClassId
      params.proIds = data.proIds
      params.merchantId = this.merchantId
      params.proType = this.catalogId
      if (this.modularClassId == 5) {
        modularTitle = 'Banner5'
      } else if (this.modularClassId == 6) {
        if (this.catalogId == 1) {
          modularTitle = this.modularTitle ? this.modularTitle : '特惠门票'
        } else {
          modularTitle = this.modularTitle ? this.modularTitle : '特惠酒店'
        }
      }
      params.modularTitle = modularTitle
      this.getLogUtils().logWithTag('confirmProduct', params)
      this.getHttpServices().getUserService().post('user/home/saveHomeProduct', params).then(res => {
        this.$message.success('添加商品成功')
        this.getChannelProductList()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.text-right {
  text-align: right;
}
</style>